<template>
  <div>
    <a-modal v-model:visible="visible" title="新增主菜单" @ok="handleOk" okText="新增" cancelText="取消" :afterClose="closeModal" width="30vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <a-form-item label="主菜单名称">
          <a-input v-model:value="data.parentName" />
        </a-form-item>

      </a-form>

    </a-modal>
  </div>
</template>

<script>
import { reactive } from "vue";
import { Add } from "/src/api/menu.js";
export default {
  components: {
  },
  data() {
    return {
      visible: this.modelValue,
      medicine: "",
      data: {
        parentName: undefined,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue', 'ok'],
  created() {

  },
  mounted() {
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: {}
    },
  },
  computed: {

  },
  methods: {
    async handleOk() {
      let _this = this;

      // 去除名称中的空格与回车
      const name = this.data.parentName ? String(this.data.parentName).replace(/\s+/g, ' ').trim() : this.data.parentName;
      let res = await Add({
        name: name,
        isRoot: true,
        clientAppName: this.record.clientAppName,
        type:"菜单"
      })
      if (res.errCode == 0) {
        _this.$message.success("新建成功", function () { });
        _this.visible = false
        this.data = {
          name: undefined,
        }
        this.$emit('ok')
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    }
    //初始化data所有数据，并关闭modal
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
